'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactClickOutside = require('react-click-outside');

var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var outlineAction = {
  NOACTION: 0,
  CLICK: 1,
  CHANGE: 2,
  BLUR: 3,
  TAB: 4
};

var NaviButton = function (_ClickOutside) {
  _inherits(NaviButton, _ClickOutside);

  function NaviButton(props) {
    _classCallCheck(this, NaviButton);

    var _this = _possibleConstructorReturn(this, (NaviButton.__proto__ || Object.getPrototypeOf(NaviButton)).call(this, props));

    _this.handleClickOutside = function () {
      if (_this.state.lastAction === outlineAction.TAB || _this.props.disabled) {
        _this.setState({
          hasOutline: true
        });
      }
    };

    _this.state = {
      hasOutline: true,
      lastAction: outlineAction.NOACTION
    };
    return _this;
  }

  _createClass(NaviButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['className']);

      return _react2.default.createElement(
        'button',
        Object.assign({
          type: 'button'
        }, props, {
          className: (0, _classnames2.default)('-btn', className, {
            'without-outline': !this.state.hasOutline
          }),
          onMouseDown: function onMouseDown() {
            _this2.setState({
              hasOutline: false,
              lastAction: outlineAction.CLICK
            });
          },
          onBlur: function onBlur() {
            _this2.setState({
              hasOutline: true
            });
          },
          onKeyDown: function onKeyDown(e) {
            if (e.which === 9 || e.keyCode === 9) {
              _this2.setState({
                hasOutline: true,
                lastAction: outlineAction.TAB
              });
            }
          }
        }),
        props.children
      );
    }
  }]);

  return NaviButton;
}((0, _reactClickOutside2.default)(_react.Component));

exports.default = NaviButton;